import React, { PureComponent } from 'react';
import { Popconfirm } from 'antd';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';

export default class List extends PureComponent {
    getColumns = () => {
        const { update, remove, download, showToken } = this.props;
        const columns = [{
            title: '投诉编号',
            dataIndex: 'complaintRecordNumber',
            key: 'complaintRecordNumber',
            width: 100,
            fixed: 'left',
        }, {
            title: '投诉来源',
            dataIndex: 'complaintFromShow',
            key: 'complaintFromShow',
            width: 100,
        }, {
            title: '投诉人职位',
            dataIndex: 'complaintPositionShow',
            key: 'complaintPositionShow',
            width: 100,
        }, {
            title: '被投诉人工号',
            dataIndex: 'complaintedEmployeeCode',
            key: 'complaintedEmployeeCode',
            width: 100,
        }, {
            title: '被投诉人姓名',
            dataIndex: 'complaintedUserName',
            key: 'complaintedUserName',
            width: 100,
        }, {
            title: '事件发生的区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 120,
        }, {
            title: '直线主管',
            dataIndex: 'leaderNameCodes',
            key: 'leaderNameCodes',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 120,
        }, {
            title: '项目名称',
            dataIndex: 'investigationSpecialName',
            key: 'investigationSpecialName',
            width: 160,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 100,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 140,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeShow',
            key: 'investigationMedicineTypeShow',
            width: 100,
        }, {
            title: '给药方式',
            dataIndex: 'administrationModeName',
            key: 'administrationModeName',
            width: 100,
        }, {
            title: '申办方 ',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            width: 160,
        }, {
            title: 'CRO',
            dataIndex: 'croName',
            key: 'croName',
            width: 160,
        }, {
            title: '津石PM',
            dataIndex: 'pmNames',
            key: 'pmNames',
            width: 100,
        }, {
            title: '涉及研究中心',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
        }, {
            title: '事件发生时间',
            dataIndex: 'happendDate',
            key: 'happendDate',
            width: 100,
            render: text => format('date', text),
        }, {
            title: '投诉内容陈诉',
            dataIndex: 'complaintTypeName',
            key: 'complaintTypeName',
            width: 160,
        }, {
            title: '投诉风险等级',
            dataIndex: 'riskLevel',
            key: 'riskLevel',
            width: 100,
        }, {
            title: '投诉可能造成的影响',
            dataIndex: 'possibleImpact',
            key: 'possibleImpact',
            width: 160,
        }, {
            title: '主要责任方',
            dataIndex: 'mainResponsible',
            key: 'mainResponsible',
            width: 100,
        }, {
            title: '与津石员工相关性',
            dataIndex: 'jsEmployeeRelevance',
            key: 'jsEmployeeRelevance',
            width: 80,
        }, {
            title: '已采取的措施或计划 ',
            dataIndex: 'majorMeasurePlan',
            key: 'majorMeasurePlan',
            width: 100,
            render: (text, record) => {
                return <a onClick={() => showToken(record)}>查看详情</a>
            }
        }, {
            title: '投诉事件处理结束与否',
            dataIndex: 'processInfoName',
            key: 'processInfoName',
            width: 100,
        }, {
            title: '最终处理情况及影响',
            dataIndex: 'processImpactInfo',
            key: 'processImpactInfo',
            width: 100,
        }, {
            title: '是否已在重大事件登记',
            dataIndex: 'isMajorEventShow',
            key: 'isMajorEventShow',
            width: 100,
        }, {
            title: '投诉风险等级是否已确认',
            dataIndex: 'isCompletedShow',
            key: 'isCompletedShow',
            width: 100,
        }, {
            title: '打回原因',
            dataIndex: 'backReason',
            key: 'backReason',
            width: 100,
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            fixed: 'right',
            width: 140,
            render: (text, record) => {
                const { canEdit, canDelete, canConfirm, isCompleted, complaintRecordId } = record;
                return (
                    <span>
                        {
                            canEdit &&
                            <span>
                                <a onClick={() => update('edit', record)}>修改</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {
                            canDelete &&
                            <span>
                                <Popconfirm title="确定删除该记录?" onConfirm={() => remove(complaintRecordId)}>
                                    <a>删除</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                            </span>
                        }
                        {
                            !canEdit &&
                            <span>
                                <a onClick={() => update('view', record)}>查看</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        <a onClick={() => download(complaintRecordId)}>下载word</a>
                        {
                            canConfirm &&
                            <span>
                                <span className="ant-divider" />
                                <a onClick={() => update('confirm', record)}>确认投诉风险等级</a>
                            </span>
                        }
                    </span>
                );
            }
        }];
        return columns;
    };

    render() {
        const { loading, data, pagination, onChange } = this.props;
        const scrollY = (document.body || document.documentElement).clientHeight - 250;
        return (
            <TableC
                loading={loading}
                columns={this.getColumns()}
                data={data}
                scrollY={scrollY}
                pagination={pagination}
                onChange={onChange}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/List.js